import axios from 'axios';
import type { AxiosRequestConfig, AxiosError } from 'axios';
import { getBaseUrl } from '../env';

// 定义自定义的请求实例接口，返回类型为响应数据而非完整响应对象
interface CustomAxiosInstance {
  get<T = any>(url: string, config?: AxiosRequestConfig): Promise<T>;
  delete<T = any>(url: string, config?: AxiosRequestConfig): Promise<T>;
  head<T = any>(url: string, config?: AxiosRequestConfig): Promise<T>;
  options<T = any>(url: string, config?: AxiosRequestConfig): Promise<T>;
  post<T = any>(
    url: string,
    data?: any,
    config?: AxiosRequestConfig
  ): Promise<T>;
  put<T = any>(
    url: string,
    data?: any,
    config?: AxiosRequestConfig
  ): Promise<T>;
  patch<T = any>(
    url: string,
    data?: any,
    config?: AxiosRequestConfig
  ): Promise<T>;
  request<T = any>(config: AxiosRequestConfig): Promise<T>;
}

/**
 * 根据不同类型创建 axios 实例
 * - 设置默认配置
 * - 根据类型设置 baseURL
 * - 设置拦截器，在请求前和响应后进行处理
 * TODO: 对错误统一处理等
 */
const createRequest = (type: 'aichat' | 'insite'): CustomAxiosInstance => {
  const request = axios.create({
    withCredentials: true,
  });

  request.interceptors.request.use(config => {
    config.baseURL = getBaseUrl(type);
    return config;
  });

  request.interceptors.response.use(
    response => {
      return response.data;
    },
    (error: AxiosError) => {
      // 错误处理，保持原有的错误结构
      return Promise.reject(error);
    }
  );

  // 类型断言，告诉 TypeScript 这个实例符合我们的自定义接口
  return request as CustomAxiosInstance;
};

const aichatRequest = createRequest('aichat');

const insiteRequest = createRequest('insite');

export { aichatRequest, insiteRequest };
export type { CustomAxiosInstance };
